import { Enumeration } from 'src/common/types';

export class RebalanceTypeEnum extends Enumeration {
  static Monthly = new RebalanceTypeEnum(1, 'Monthly', 'Monthly');
  static Quarterly = new RebalanceTypeEnum(2, 'Quarterly', 'Quarterly');
  static BiYearly = new RebalanceTypeEnum(3, 'BiYearly', 'BiYearly');
  static Annual = new RebalanceTypeEnum(4, 'Annual', 'Annual');

  static getById = (status: number): RebalanceTypeEnum | undefined => {
    return Object.values(RebalanceTypeEnum)
      .filter((t) => t instanceof RebalanceTypeEnum)
      .find((t: RebalanceTypeEnum) => t.id === status);
  };

  static getByName = (name: string): RebalanceTypeEnum | undefined => {
    return Object.values(RebalanceTypeEnum)
      .filter((t) => t instanceof RebalanceTypeEnum)
      .find((t: RebalanceTypeEnum) => t.name.toLowerCase() === name.toLowerCase());
  };
}

export class FeeNatureEnum extends Enumeration {
  static Ongoing = new FeeNatureEnum(1, 'Ongoing', 'Ongoing');
  static OneOff = new FeeNatureEnum(2, 'OneOff', 'One Off');
  static EventBase = new FeeNatureEnum(3, 'EventBase', 'Event Base');

  static getById = (status: number): FeeNatureEnum | undefined => {
    return Object.values(FeeNatureEnum)
      .filter((t) => t instanceof FeeNatureEnum)
      .find((t: FeeNatureEnum) => t.id === status);
  };
}

export class FeeSubCategoryEnum extends Enumeration {
  static OngoingFee = new FeeSubCategoryEnum(5, 'OngoingFee', 'Ongoing Fee');
  static PortfolioManagementFee = new FeeSubCategoryEnum(6, 'PortfolioManagementFee', 'Portfolio Management Fee');
  static UpfrontFee = new FeeSubCategoryEnum(7, 'UpfrontFee', 'Upfront Fee');
  static AdminFeeOncharge = new FeeSubCategoryEnum(8, 'AdminFeeOncharge', 'Admin Fee Oncharge');
  static ProductFee = new FeeSubCategoryEnum(14, 'ProductFee', 'Product Fee');
  static OngoingFeeOverride = new FeeSubCategoryEnum(15, 'OngoingFeeOverride', 'Ongoing Fee Override');
  static PortfolioManagementFeeOverride = new FeeSubCategoryEnum(16, 'PortfolioManagementFeeOverride', 'Portfolio Management Fee Override');
  static AdminFeeOnchargeOverride = new FeeSubCategoryEnum(17, 'AdminFeeOnchargeOverride', 'Admin Fee Oncharge Override');

  static getById = (status: number): FeeSubCategoryEnum | undefined => {
    return Object.values(FeeSubCategoryEnum)
      .filter((t) => t instanceof FeeSubCategoryEnum)
      .find((t: FeeSubCategoryEnum) => t.id === status);
  };
}

export class FeeDisplayFrequencyFormEnum extends Enumeration {
  static Annual = new FeeDisplayFrequencyFormEnum(1, 'annual', 'Annual');
  static Monthly = new FeeDisplayFrequencyFormEnum(3, 'monthly', 'Monthly');

  static getById = (status: number): FeeDisplayFrequencyFormEnum | undefined => {
    return Object.values(FeeDisplayFrequencyFormEnum)
      .filter((t) => t instanceof FeeDisplayFrequencyFormEnum)
      .find((t: FeeDisplayFrequencyFormEnum) => t.id === status);
  };
}

export class FeeDisplayFrequencyEnum extends FeeDisplayFrequencyFormEnum {
  static OneOff = new FeeDisplayFrequencyEnum(2, 'OneOff', 'One Off');

  static getById = (status: number): FeeDisplayFrequencyEnum | undefined => {
    return super.getById(status) || Object.values(FeeDisplayFrequencyEnum)
      .filter((t) => t instanceof FeeDisplayFrequencyEnum)
      .find((t: FeeDisplayFrequencyEnum) => t.id === status);
  };
}

export class FeeValueMethodEnum extends Enumeration {
  static Dollar = new FeeValueMethodEnum(1, 'dollar', '$');
  static Percent = new FeeValueMethodEnum(2, 'percent', '%');

  static getById = (status: number): FeeValueMethodEnum | undefined => {
    return Object.values(FeeValueMethodEnum)
      .filter((t) => t instanceof FeeValueMethodEnum)
      .find((t: FeeValueMethodEnum) => t.id === status);
  };
}
